export const createPaymentProvidersRequests = (client) => ({
    listPaymentProviders: async (params) => {
        const { data, meta, links } = await client.api.get("payment_providers", {
            params: params,
        });
        return { data, meta, links };
    },
    getPaymentProvider: async (id, params) => {
        const { data } = await client.api.get(`payment_providers/${id}`, {
            params: params,
        });
        return { data };
    },
});
//# sourceMappingURL=index.js.map